<div class="modal-header">
	<button class="close" (click)="closeModalAndBack()">&times;</button>
	<h4 class="modal-title">{{ modalTitle() }}</h4>
</div>
<div style="min-height: 100px">
	<div class="card-body p-4">
		@if (errorMessage()) {
			<alert type="danger">{{ errorMessage() }}</alert>
		}
		<app-component-loader [isLoading]="isLoadingCompany()">
			@if (companyData()) {
				<app-stepper [selectedStep]="selectedStage()" (stepChanged)="onStepChanged($event)">
					<app-step tag="companySummary">
						@if (isArchived()) {
							<alert type="info" class="company-preview-archive-banner mb-3">
								{{ archiveBannerMessage() }}
							</alert>
						}
						@if (thisIsMeSuccessMessage()) {
							<alert type="success" class="mb-3">
								<span [innerHTML]="verificationSuccessMessageHtml"></span>
							</alert>
						}
						@if (verificationNotDirectorResult()) {
							<alert type="warning" class="mb-3">
								Unfortunately, you do not appear to be an active director of this company.<br />
								Please request access as an authorised representative or
								<a [href]="helpRequestAccessUrl()" target="_blank" rel="noopener noreferrer">contact support</a>.
							</alert>
						}
						<div class="custom-table" [class.toggled]="toggleStates()['companySummary']">
							<div class="custom-table-header flex-between" (click)="toggleTableBody('companySummary')">
								<div class="custom-table-header-cell flex-left">
									<p>Company Summary</p>
								</div>
								<button class="flex-center">
									<app-icon [icon]="toggleStates()['companySummary'] ? faAngleDownIcon : faAngleUpIcon" />
								</button>
							</div>

							<div class="custom-table-body">
								<div class="custom-table-row flex-left">
									<p class="custom-table-cell">Company Name</p>
									<p class="custom-table-cell">{{ companyData().CompanyName }}</p>
								</div>

								<div class="custom-table-row flex-left">
									<p class="custom-table-cell">Registration Number</p>
									<p class="custom-table-cell">
										{{ companyData().CompanyRegistrationNumber }}
									</p>
								</div>

								<div class="custom-table-row flex-left">
									<p class="custom-table-cell">Company Status</p>
									<p class="custom-table-cell">
										<span
											class="status"
											[class.overdue]="
												companyData().CompanyStatus === 'Deregistration Final' ||
												companyData().CompanyStatus === 'Conversion CO/CC or CC/CO'
											"
											[class.soon]="
												companyData().CompanyStatus === 'Deregistration Process' ||
												companyData().CompanyStatus === 'AR Final deregistration' ||
												companyData().CompanyStatus === 'Business Rescue'
											"
											[class.active]="companyData().CompanyStatus === 'In Business'"
											>{{ companyData().CompanyStatus | uppercase }}
										</span>
									</p>
								</div>

								@if (annualReturnComplianceLabel(); as annualReturnLabel) {
									<div class="custom-table-row flex-left">
										<p class="custom-table-cell">CIPC Annual Returns</p>
										<p class="custom-table-cell">
											<span
												class="status annual-return-compliance"
												[class.success]="companyData().annual_return_compliant === true"
												[class.danger]="companyData().annual_return_compliant === false"
												>{{ annualReturnLabel }}</span
											>
										</p>
									</div>
								}

								<div class="custom-table-row flex-left">
									<p class="custom-table-cell">Incorporation Date</p>
									<p class="custom-table-cell">
										{{ companyData().RegistrationDate | date: 'yyyy-MM-dd' }}
									</p>
								</div>

								<div class="custom-table-row flex-left">
									<p class="custom-table-cell">Financial Year End</p>
									<p class="custom-table-cell">
										{{ sharedService.monthNames[companyData().FinancialYearEnd - 1] }}
									</p>
								</div>

								<div class="custom-table-row address flex-left">
									<p class="custom-table-cell">Registered Address</p>
									<address class="custom-table-cell">
										{{ companyData().PhysicalAddressLine1 }}<br />
										{{ companyData().PhysicalAddressLine2 }}<br />
										{{ companyData().PhysicalAddressLine3 }}<br />
										{{ companyData().PhysicalAddressLine4 }}<br />
										{{ companyData().PhysicalPostCode }}
									</address>
								</div>
							</div>
						</div>

						<div class="custom-table director-summary" [class.toggled]="toggleStates()['directorSummary']">
							<div class="custom-table-header flex-between" (click)="toggleTableBody('directorSummary')">
								<div class="custom-table-header-cell flex-left">
									<p>
										{{ companyData().CompanyType.includes('Corporation') ? 'Member Summary' : 'Director Summary' }}
									</p>
								</div>
								<button class="flex-center">
									<app-icon [icon]="toggleStates()['directorSummary'] ? faAngleDownIcon : faAngleUpIcon" />
								</button>
							</div>

							<div class="custom-table-body">
								@for (director of companyData().directors; track director.dir_id) {
									@if (director.dir_status_descr === 'Active') {
										<div
											class="custom-table-row flex-left director director-row-actions d-flex align-items-center justify-content-between cursor-pointer"
											(click)="searchDirector(director)"
											(mouseenter)="toggleDirectorFolder(true, director.id_no)"
											(mouseleave)="toggleDirectorFolder(false, null)"
										>
											<div class="director-name-cell d-flex align-items-center flex-grow-1 gap-3">
												<span
													class="director-flag fi fis fi-{{
														director.country_code ||
															(director.rsa_resident === '1' ? 'ZA' : null) ||
															companyData().CountryCode ||
															'za' | lowercase
													}}"
												></span>
												<p class="text-decoration-none mb-0">{{ director.first_names }} {{ director.surname }}</p>
											</div>
											<div class="director-actions d-flex align-items-center gap-3">
												<button type="button" class="dataTableButton director-folder-icon">
													<app-icon
														[icon]="
															openDirectorFolder() && hoveredDirectorId() === director.id_no
																? faFolderOpenIcon
																: faFolderIcon
														"
													/>
												</button>
											</div>
										</div>
									}
								}
							</div>
						</div>

						@if (companyExists === 'Request access') {
							<div class="modal-footer d-flex align-items-center gap-2" style="padding: 30px 0 15px 0">
								<a class="btn-nav btn-prev" style="padding: 0px 20px !important" (click)="modalRef.hide(); onBack()"
									>Back</a
								>
								<button
									class="btn btn-primary"
									[disabled]="requestAccessState() !== 'idle'"
									(click)="goToRequestAccessChoice()"
								>
									@if (requestAccessState() === 'idle') {
										Request Access
									}
									@if (requestAccessState() === 'pending') {
										<app-icon [icon]="faCircleNotchIcon" [spin]="true" />
										Please wait...
									}
									@if (requestAccessState() === 'requested') {
										Requested
									}
								</button>
							</div>
						} @else if (companyExists === 'Already added') {
							<div class="modal-footer" style="padding: 30px 0 15px 0">
								<a class="btn-nav btn-prev" style="padding: 0px 20px !important" (click)="modalRef.hide(); onBack()"
									>Back</a
								>
								<button class="btn btn-primary" (click)="goToDashboard()">Go To Dashboard</button>
							</div>
						} @else if (companyExists === 'Archived') {
							<div class="modal-footer" style="padding: 30px 0 15px 0">
								<a class="btn-nav btn-prev" style="padding: 0px 20px !important" (click)="modalRef.hide(); onBack()"
									>Back</a
								>
								<button
									class="btn btn-primary company-preview-restore-button"
									[disabled]="!canRestore()"
									(click)="openRestoreModal()"
								>
									Restore Company
								</button>
							</div>
							@if (!canRestore()) {
								<p class="company-preview-restore-note">
									This company can only be restored by an account admin. Contact an account admin for help.
								</p>
							}
						} @else {
							@if (accountService.isFree() || accountService.isUnlimited() || accountService.isSpecialOffer()) {
								<div class="modal-footer" style="padding: 30px 0 15px 0">
									<a class="btn-nav btn-prev" style="padding: 0px 20px !important" (click)="modalRef.hide(); onBack()"
										>Back</a
									>
									<button class="btn btn-primary" (click)="addCompany(accountService.addCompanyAsSubscribed())">
										Add Company
									</button>
								</div>
							}
							@if (!accountService.isFree() && !accountService.isUnlimited() && !accountService.isSpecialOffer()) {
								<div class="footer d-flex align-items-center justify-content-center gap-2">
									<button class="btn btn-primary btn-orange" (click)="addCompany(false)">Pay As You Go</button>
									<button class="btn btn-primary" (click)="addCompany(true)">Subscribe</button>
								</div>
								<div class="modal-footer">
									<a [href]="helpKnowledgeBaseUrl + '25788889'" target="_blank">What's the difference?</a>
								</div>
							}
						}
					</app-step>

					<app-step tag="requestAccessChoice">
						<div class="request-access-choice">
							@if (showNotDirectorAlertOnRequestStep()) {
								<alert type="info" class="mb-3">
									You do not appear to be an active director. Please request access as an authorised representative or
									<a [href]="helpRequestAccessUrl()" target="_blank" rel="noopener noreferrer">contact support</a>.
								</alert>
							} @else {
								<alert type="info" class="mb-3">
									<b>Please note:</b> Personal information is protected by the InfoDocs
									<a [href]="privacyPolicyUrl" target="_blank">privacy policy</a>.
								</alert>
							}
							<p class="text-body-secondary mb-3">Please verify your identity to access this company.</p>
							<div class="form-group required">
								<label class="radio-label control-label-lite d-block mb-2">
									<input
										type="radio"
										class="radio-group"
										name="requestAccessChoice"
										[ngModel]="requestAccessChoiceSelected()"
										(ngModelChange)="requestAccessChoiceSelected.set($event)"
										[disabled]="verificationNotDirectorResult()"
										value="verify"
									/>
									I am a {{ isCloseCorporation() ? 'member' : 'director' }} of this company
								</label>
								<label class="radio-label control-label-lite d-block mb-2">
									<input
										type="radio"
										class="radio-group"
										name="requestAccessChoice"
										[ngModel]="requestAccessChoiceSelected()"
										(ngModelChange)="requestAccessChoiceSelected.set($event)"
										value="preview"
									/>
									I am an authorised representative
								</label>
							</div>
							<div class="modal-footer">
								<a class="btn-nav btn-prev" (click)="onBackFromRequestAccessChoice()">Back</a>
								<button type="button" class="btn btn-primary" (click)="onRequestAccessChoiceConfirm()">
									{{ requestAccessChoiceButtonLabel }}
								</button>
							</div>
						</div>
					</app-step>

					<app-step tag="requestPreview">
						<div class="request-access-preview">
							<label class="control-label">Preview Request Email</label>
							<app-component-loader [isLoading]="isRequestPreviewLoading()" process="Loading preview">
								<div class="email-preview border rounded p-3 mb-3 bg-body">
									<p class="mb-2">From: InfoDocs &lt;support&#64;infodocs.co.za&gt;</p>
									<p class="mb-2">Subject: Request Access to {{ companyData()?.CompanyName ?? '[Company Name]' }}</p>
								</div>
								<div class="email-preview border rounded p-3 mb-3 bg-body">
									<p class="mb-2">Dear {{ previewAccountName() ?? '[Account Name]' }}</p>
									<p class="mb-2">{{ defaultIntro() }}</p>
									<p class="mb-2">Please select which option you would prefer from the following:</p>
									<ul class="list-unstyled mb-3 ms-3">
										<li>Deny the request</li>
										<li>Grant view-only access</li>
										<li>Grant edit access</li>
										<li>Transfer ownership (retain third party access)</li>
										<li>Transfer ownership (remove access)</li>
									</ul>
									<p class="mb-2">
										For feedback or support, simply contact us at
										<a href="mailto:support@infodocs.co.za">support&#64;infodocs.co.za</a>.
									</p>
									<p class="mb-2">Sincerely</p>
									<p class="mb-0">InfoDocs</p>
								</div>
							</app-component-loader>
							<div class="modal-footer">
								<a class="btn-nav btn-prev" (click)="selectedStage.set(CompanyPreviewStage.REQUEST_ACCESS_CHOICE)"
									>Back</a
								>
								<button
									type="button"
									class="btn btn-primary"
									[disabled]="isRequestPreviewLoading() || isRequestPreviewSubmitting()"
									(click)="requestAccessWithIntro(defaultIntro())"
								>
									@if (isRequestPreviewSubmitting()) {
										<app-icon [icon]="faCircleNotchIcon" [spin]="true" />
										Sending...
									} @else {
										Send
									}
								</button>
							</div>
						</div>
					</app-step>

					<app-step tag="verifyUpload">
						<app-upload-id-form (formSubmitted)="onUploadSuccess($event)"></app-upload-id-form>
						<a class="btn-nav btn-prev btn-back-from-verify" (click)="onBackFromVerify()">Back</a>
					</app-step>

					<app-step tag="verifyReview">
						@if (verificationError()) {
							<alert type="danger">{{ verificationError() }}</alert>
						}
						<app-verify-review-form
							[initialValue]="formInitialValue"
							[isBusy]="isVerificationSubmitting()"
							(formSubmitted)="onVerificationFormSubmitted($event)"
						/>
						<a class="btn-nav btn-prev btn-back-from-verify" (click)="onBackFromVerify()">Back</a>
					</app-step>

					<app-step tag="importing">
						@if (thisIsMeSuccessMessage()) {
							<alert type="success" class="mb-3">
								<span [innerHTML]="verificationSuccessMessageHtml"></span>
							</alert>
						}
						<div class="importing-company company-setup">
							<p class="mt-3">Please wait while we import your company records</p>
							<img src="assets/img/company-import.png" style="width: 70%" alt="Company Importing" />
						</div>
					</app-step>

					<app-step tag="success">
						<div class="confirmation-dialog company-setup text-center">
							<p class="mt-3">Congratulations! Your company has been added.</p>
							<img src="assets/img/company-success.png" style="width: 75%" alt="Company Success" />
						</div>
						<div class="modal-footer">
							<button class="btn btn-primary" (click)="goToDashboard()">Go To Dashboard</button>
						</div>
					</app-step>

					<app-step tag="companyLimit">
						<app-company-limit-notice />
						<div class="modal-footer">
							<a
								class="btn-nav btn-prev"
								style="padding: 0px 20px !important"
								(click)="selectedStage.set(CompanyPreviewStage.COMPANY_SUMMARY)"
								>Back</a
							>
							<button class="btn btn-primary" (click)="closeModalAndBack()">Close</button>
						</div>
					</app-step>
				</app-stepper>
			}
		</app-component-loader>
	</div>
</div>
